function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("title", null, "6229CFCF-FEBB-4C56-ADB7-53B158ACD4BE");
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Lodge-enquiry",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "lodge-enq-lodged-open-MD",
  transform: "translate(-660.000000, -302.000000)",
  stroke: "#0283FB"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-20",
  transform: "translate(64.000000, 288.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ui/icon/utility/24/water-circle",
  transform: "translate(596.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "circle",
  cx: 12,
  cy: 12,
  r: 11.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9998132,5.8471545 C13.1712839,7.47421468 16.5,12.2782884 16.5,14.3333333 C16.5,15.4802089 15.9989682,16.5166834 15.1943748,17.2676373 C14.376863,18.0306483 13.2467898,18.5 12,18.5 C10.7532102,18.5 9.62313701,18.0306483 8.80562521,17.2676373 C8.00103177,16.5166834 7.5,15.4802089 7.5,14.3333333 C7.5,12.2691747 10.8280565,7.47188941 11.9998132,5.8471545 Z",
  id: "shape"
})))));
const SvgUiIconUtility24WaterCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility24WaterCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-24-water-circle.d377724e.svg";
export { ForwardRef as ReactComponent };